import { MtUser } from "server/models"
import { OrderType } from "client/utils"
import { UserFilters } from "client/store"

export interface TaskObserverList { [taskId: number]: readonly number[]}

export interface TaskObserverState {
    taskObserverList: TaskObserverList

    notAssignedUsers: {
        userIds: readonly number[]
        sortColumn: keyof MtUser
        sortOrder: OrderType
        filters: UserFilters
        selected: readonly number[]
    }
}

export const TASK_OBSERVER_LIST = "TASK_OBSERVER_LIST"

export const NOT_ASSIGNED_TASK_OBSERVER_IDS = "NOT_ASSIGNED_TASK_OBSERVER_IDS"
export const NOT_ASSIGNED_TASK_OBSERVER_SORT = "NOT_ASSIGNED_TASK_OBSERVER_SORT"
export const NOT_ASSIGNED_TASK_OBSERVER_FILTERS = "NOT_ASSIGNED_TASK_OBSERVER_FILTERS"
export const NOT_ASSIGNED_TASK_OBSERVER_SELECTED = "NOT_ASSIGNED_TASK_OBSERVER_SELECTED"
